import _ from 'lodash';

export default {
  checkForDuplicates: function (array) { // https://stackoverflow.com/a/28461122/1927876
    return _.uniq(array).length !== array.length;
  },
  getHoleCardsArrayFromObj: function (obj) {
    let arr = [];

    if (obj.holeCardOne) {
      arr.push(obj.holeCardOne);
    }

    if (obj.holeCardTwo) {
      arr.push(obj.holeCardTwo);
    }

    return arr;
  },
  getBoardCardsArrayFromObj: function (obj) {
    let arr = [];

    if (obj.flop1) {
      arr.push(obj.flop1);
    }

    if (obj.flop2) {
      arr.push(obj.flop2);
    }

    if (obj.flop3) {
      arr.push(obj.flop3);
    }

    if (obj.turn) {
      arr.push(obj.turn);
    }

    if (obj.river) {
      arr.push(obj.river);
    }

    return arr;
  },
  includes: function (arr, predicate) {
    for (let i = 0; i < arr.length; i++) {
      if (predicate(arr[i])) {
        return true;
      }
    }

    return false;
  },
  getArrayItemFromArrayOfIndexes: function (fullArray, arrayOfIndexes) {
    let curr = fullArray[arrayOfIndexes[0]];

    for (let i = 1; i < arrayOfIndexes.length; i++) {
      curr = curr.children[arrayOfIndexes[i]];
    }

    return curr;
  },
  getArrayFromNextToLastArrayIndex: function (fullArray, arrayOfIndexes) {
    let curr = fullArray;

    for (let i = 0; i < arrayOfIndexes.length - 1; i++) {
      curr = curr[arrayOfIndexes[i]].children;
    }

    return curr;
  },
  forEachLeaf: function (arr, callback, indexesList = []) {
    arr.forEach(function (el, i) {
      let newIndexesList = _.cloneDeep(indexesList);
      newIndexesList.push(i);

      if (!el.children) {
        callback(el, newIndexesList)
      } else {
        this.forEachLeaf(el.children, callback, newIndexesList);
      }
    }, this);
  },
  forEachParent: function (arr, callback, indexesList = []) {
    arr.forEach(function (el, i) {
      let newIndexesList = _.cloneDeep(indexesList);
      newIndexesList.push(i);

      if (el.children) {
        this.forEachParent(el.children, callback, newIndexesList);
        callback(el, newIndexesList);
      }
    }, this);
  },
  forEachNode: function (arr, callback, indexesList = []) {
    arr.forEach(function (el, i) {
      let newIndexesList = _.cloneDeep(indexesList);
      newIndexesList.push(i);
      callback(el, newIndexesList);

      if (el.children) {
        this.forEachNode(el.children, callback, newIndexesList);
      }
    }, this);
  },
  getHTMLForSuitIcons: function (suits) {
    if (suits === 'hh') {
      return '<span style="color: red;">&hearts;&hearts;</span>';
    } else if (suits === 'dd') {
      return '<span style="color: red;">&diams;&diams;</span>';
    } else if (suits === 'ss') {
      return '<span>&spades;&spades;</span>';
    } else if (suits === 'cc') {
      return '<span>&clubs;&clubs;</span>';
    }

    // offsuit + pairs
    else if (suits === 'hd') {
      return '<span style="color: red;">&hearts;</span><span style="color: red;">&diams;</span>';
    } else if (suits === 'hs') {
      return '<span style="color: red;">&hearts;</span>&spades;';
    } else if (suits === 'hc') {
      return '<span style="color: red;">&hearts;</span>&clubs;';
    } else if (suits === 'dh') {
      return '<span style="color: red;">&diams;</span><span style="color: red;">&hearts;</span>';
    } else if (suits === 'ds') {
      return '<span style="color: red;">&diams;</span>&spades;';
    } else if (suits === 'dc') {
      return '<span style="color: red;">&diams;</span>&clubs;';
    } else if (suits === 'sh') {
      return '&spades;<span style="color: red;">&hearts;</span>';
    } else if (suits === 'sd') {
      return '&spades;<span style="color: red;">&diams;</span>';
    } else if (suits === 'sc') {
      return '&spades;&clubs;';
    } else if (suits === 'ch') {
      return '&clubs;<span style="color: red;">&hearts;</span>';
    } else if (suits === 'cd') {
      return '&clubs;<span style="color: red;">&diams;</span>';
    } else if (suits === 'cs') {
      return '&clubs;&spades;';
    }

    else {
      throw new Error('Invalid value of suits.');
    }
  },
  doArraysContainSameElements: function (array1, array2) {
    return _.isEmpty(_.xor(array1, array2))
  },
  getPlayerStateIndexFromStreet: function (street) {
    if (street === 'flop') {
      return 1;
    } else if (street === 'turn') {
      return 2;
    } else if (street === 'river') {
      return 3;
    }
  },
  getDaysBetweenDates: function (startDate, endDate) {
    const millisecondsPerDay = 24 * 60 * 60 * 1000;

    return (this._treatDateAsUTC(endDate) - this._treatDateAsUTC(startDate)) / millisecondsPerDay;
  },
  _treatDateAsUTC: function (date) {
    let result = new Date(date);

    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());

    return result;
  },
  handleNetworkError: function (e) {
    const error = (e && e.response && e.response.data && e.response.data.err) ? e.response.data.err : 'Unknown error. Email contact@sixplusholdem.com for help.';

    alert(error);
  },
};



// WEBPACK FOOTER //
// ./src/services/utilities/general.js